import {ChangeDetectorRef, Component, inject, Inject, model, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'ngx-crud-manager-import',
    templateUrl: './ngx-crud-import.component.html',
    styleUrls: ['./ngx-crud-import.component.scss'],
    standalone: false
})
export class NgxCrudImportComponent implements OnInit {
  roles = [];

  items = [];

  selectedItems = model<number[]>([]);

  private readonly cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  constructor(
    private matDialogRef: MatDialogRef<NgxCrudImportComponent>,
    @Inject(MAT_DIALOG_DATA) private data,
  ) {

  }

  ngOnInit() {
    if (this.data) {
      this.items = this.data;
    }
  }

  import() {
    this.matDialogRef.close(this.selectedItems());
  }

  closeDialog() {
    this.matDialogRef.close();
  }

}
